module.exports = __webpack_public_path__ + "img/55c2e1e.jpg";